var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlackFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1923 8.39782V11.2777H20.4265C19.7463 11.2777 19.3143 11.4045 19.1314 11.6568C18.896 11.9346 18.7783 12.3268 18.7783 12.8313V14.8783H22.0746L21.6427 18.0991H18.7783V26.2842H15.3644V18.0991H12.5V14.8783H15.3644V12.5285C15.3644 11.2147 15.7439 10.1669 16.5023 9.38319C17.3131 8.65075 18.36 8.28418 19.6415 8.28418C20.7142 8.28418 21.5645 8.32229 22.1923 8.39782Z",
  fill: "#001246"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 0.78418,
  width: 33,
  height: 33,
  rx: 16.5,
  stroke: "black"
})));
export default SvgBlackFacebookIcon;